import { useState, useEffect } from "react";
import { AlertCircle } from "lucide-react";
import api from "../../../configs/api";
import LandFilter from "../../../components/public/userLand/LandFilter";
import { TrackImpression } from "../../../components/public/trackers/TrackImpression.jsx";
import ContactOwnerModal from "../../../components/modals/ContactOwnerModal.jsx";
import useContactModal from "../../../hooks/useContactModal.js";
import PropertyCard from "../../../components/public/userCommon/PropertyCard.jsx";

const ListingLandProperties = () => {
  const [projects, setProjects] = useState([]);
  const [propertyData, setPropertyData] = useState({});
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { closeModal, isOpen, openModal } = useContactModal();

  // FILTER STATES
  const [selectedFilters, setSelectedFilters] = useState({
    propertyTypes: [],
    bedrooms: [],
    furnishedStatus: [],
    postedBy: [],
    availabilityStatus: [],
    amenities: [],
    reraApproved: [],
    withPhotos: false,
    withVideos: false,
  });

  const [budgetRange, setBudgetRange] = useState([100, 10000000]);
  const [sizeRange, setSizeRange] = useState([100, 10000]);

  const resetFilters = () => {
    setSelectedFilters({
      propertyTypes: [],
      bedrooms: [],
      furnishedStatus: [],
      postedBy: [],
      availabilityStatus: [],
      amenities: [],
      reraApproved: [],
      withPhotos: false,
      withVideos: false,
    });
    setBudgetRange([100, 10000000]);
    setSizeRange([100, 10000]);
  };

  // FETCH LAND PROJECTS
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/properties/");
        const lands = res.data.data.filter((p) => p.type === "land");
        setProjects(lands);
        setFilteredProjects(lands);
      } catch (err) {
        console.error("ERROR FETCHING LAND PROJECTS:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // FILTER LAND PROJECTS
  useEffect(() => {
    const matchFilters = (p) => {
      const price = p.property?.expectedPrice;
      const area = p.property?.carpetArea?.value;

      if (price < budgetRange[0] || price > budgetRange[1]) return false;
      if (area < sizeRange[0] || area > sizeRange[1]) return false;

      if (
        selectedFilters.availabilityStatus.length > 0 &&
        !selectedFilters.availabilityStatus.includes(p.listingType)
      )
        return false;

      if (
        selectedFilters.amenities.length > 0 &&
        !selectedFilters.amenities.every((a) =>
          p.property?.amenities?.includes(a)
        )
      )
        return false;

      if (selectedFilters.withPhotos && !(p.images?.length > 0)) return false;
      if (selectedFilters.withVideos && !(p.videos?.length > 0)) return false;

      return true;
    };

    setFilteredProjects(projects.filter(matchFilters));
  }, [projects, selectedFilters, budgetRange, sizeRange]);

  return (
    <div className="w-full bg-gray-50 py-10">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* FILTER SECTION */}
          <LandFilter
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            budgetRange={budgetRange}
            setBudgetRange={setBudgetRange}
            sizeRange={sizeRange}
            setSizeRange={setSizeRange}
            resetFilters={resetFilters}
          />

          {/* LISTING */}
          <div className="col-span-1 lg:col-span-3">
            <h2 className="text-xl md:text-2xl font-medium mb-2 text-gray-900">
              Land Properties for Sale in Bhubaneswar
            </h2>

            <p className="text-gray-600 mb-6">
              Explore approved land listings with detailed information and
              verified ownership.
            </p>

            {!loading && (
              <div
                className="
                  grid 
                  grid-cols-1 
                  sm:grid-cols-2
                  md:grid-cols-1 
                  gap-4 
                  sm:gap-5 
                  md:gap-6
                      "
              >
                {filteredProjects.length > 0 ? (
                  filteredProjects.map((p) => (
                    <TrackImpression key={p._id} propertyId={p._id}>
                      <PropertyCard
                        property={p}
                        openModal={openModal}
                        setPropertyData={setPropertyData}
                      />
                    </TrackImpression>
                  ))
                ) : (
                  <div className="col-span-full bg-white rounded-lg shadow-md p-8 text-center">
                    <div className="flex flex-col items-center justify-center py-8">
                      <AlertCircle className="w-16 h-16 text-gray-400 mb-4" />
                      <p className="text-gray-500 text-lg mb-2">
                        No properties found
                      </p>
                      <button
                        onClick={resetFilters}
                        className="px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
                      >
                        Reset Filters
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <ContactOwnerModal
        propertyData={propertyData}
        isOpen={isOpen}
        onClose={closeModal}
      />
    </div>
  );
};

export default ListingLandProperties;

// import { useState, useEffect } from "react";
// import { FaHeart, FaCamera } from "react-icons/fa";
// import { Phone } from "lucide-react";
// import propertiesImg from "../../../assets-user/LandPropertyImg.png";
// import api from "../../../configs/api";
// import { formatPrice } from "../../../utils/helpers";
// import LandFilter from "../../../components/public/userLand/LandFilter";
// import { useNavigate } from "react-router-dom";

// const LandProjectCard = ({ project, index }) => {
//   const [liked, setLiked] = useState(false);
//   const navigate = useNavigate();

//   const thumbnail =
//     project.images && project.images.length > 0
//       ? project.images.find((img) => img.isThumbnail)?.url ||
//         project.images[0]?.url
//       : propertiesImg;

//   return (
//     <div
//       data-aos="fade-up"
//       data-aos-delay={index * 100}
//       data-aos-duration="700"
//       className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col xl:flex-row p-4"
//     >
//       <div className="relative xl:w-1/3">
//         <img
//           src={thumbnail}
//           alt={project.title || "Land Property"}
//           className="w-full h-[290px] object-cover rounded-lg"
//         />
//         <button
//           onClick={() => setLiked(!liked)}
//           className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-md hover:scale-110 transition-transform"
//           aria-label="Like button"
//         >
//           <FaHeart
//             className={`text-lg ${liked ? "text-red-500" : "text-gray-400"}`}
//           />
//         </button>
//         <div className="absolute bottom-3 left-3 bg-black bg-opacity-60 text-white px-3 py-1.5 rounded-full flex items-center gap-1 text-sm font-semibold">
//           <FaCamera className="text-xs" />
//           <span>{project.images?.length || 0}</span>
//         </div>
//       </div>
//       <div className="px-1 xl:px-6 flex-1 flex flex-col mt-2">
//         <div className="flex items-start justify-between mb-2 md:mb-3">
//           <div className="flex-1">
//             <h3 className="text-lg sm:text-xl md:text-2xl font-medium mb-1 text-gray-900">
//               {project.title || "Plot for Sale"}
//             </h3>
//             <div className="flex justify-between">
//               <p className="text-xs md:text-sm text-gray-500 flex items-center gap-1">
//                 📍 {project.location?.address?.formatted || "Bhubaneswar"}
//               </p>
//               <p className="text-xs md:text-sm text-gray-500 whitespace-nowrap">
//                 {new Date(project.createdAt).toLocaleDateString()}
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="grid grid-cols-3 gap-3 md:gap-4 mb-3 md:mb-4 py-2 md:py-3">
//           <div>
//             <p className="text-sm md:text-base lg:text-lg font-bold text-gray-900">
//               {project?.property?.expectedPrice
//                 ? formatPrice(project.property.expectedPrice)
//                 : "N/A"}
//             </p>
//             <p className="text-xs md:text-sm text-gray-600 font-normal">
//               {project?.property?.pricePerSqft
//                 ? `${formatPrice(project.property.pricePerSqft)}/sqft`
//                 : "N/A"}
//             </p>
//           </div>
//           <div>
//             <p className="text-sm md:text-base lg:text-lg font-bold text-gray-900">
//               {project?.property?.carpetArea?.value || "N/A"}{" "}
//               {project?.property?.carpetArea?.unit || "N/A"}
//             </p>
//             <p className="text-xs md:text-sm text-gray-600 font-normal">
//               Plot Area
//             </p>
//           </div>
//           {project.listingType && (
//             <div>
//               <p className="text-sm md:text-base lg:text-lg font-bold text-gray-900">
//                 {project.listingType}
//               </p>
//               <p className="text-xs md:text-sm text-gray-600 font-normal">
//                 For
//               </p>
//             </div>
//           )}
//         </div>
//         <p className="text-xs md:text-sm text-gray-600 font-normal mb-3 md:mb-4 line-clamp-2">
//           {project.description ||
//             "A well-located land plot with excellent growth potential."}
//         </p>
//         <div className="flex flex-wrap items-center justify-between border-t border-gray-200 pt-3 md:pt-4 gap-3">
//           <div className="bg-[#FFE8E4] rounded-tr-3xl py-2 px-6 flex items-center flex-shrink-0">
//             <div className="w-10 h-10 md:w-12 md:h-12 bg-gray-900 rounded-full flex items-center justify-center flex-shrink-0">
//               <span className="text-white font-bold text-base md:text-lg">
//                 {project.listedBy?.name
//                   ? project.listedBy.name[0]?.toUpperCase()
//                   : "U"}
//               </span>
//             </div>
//             <div className="ml-3">
//               <p className="font-semibold text-gray-900 text-xs md:text-sm">
//                 {project.listedBy?.name || "Owner"}
//               </p>
//               <p className="text-gray-500 text-xs">Owner</p>
//             </div>
//           </div>
//           <div className="flex gap-2 flex-shrink-0">
//             <button className="px-3 md:px-4 py-2 bg-white border-2 border-red-500 text-red-500 rounded-lg font-semibold hover:bg-red-50 transition-colors text-xs md:text-sm flex items-center gap-1">
//               <Phone className="w-3 h-3 md:w-4 md:h-4" />
//               <span>View Number</span>
//             </button>
//             <button
//               onClick={() => {
//                 navigate(`${project._id}`);
//                 window.scrollTo({ top: 0, behavior: "smooth" });
//               }}
//               className="px-3 md:px-4 py-2 bg-red-500 text-white rounded-lg font-semibold hover:bg-red-600 transition-colors text-xs md:text-sm flex items-center gap-1"
//             >
//               <Phone className="w-3 h-3 md:w-4 md:h-4" />
//               <span>Contact Owner</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const ListingLandProperties = () => {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filter states lifted here
//   const [selectedFilters, setSelectedFilters] = useState({
//     propertyTypes: [],
//     bedrooms: [],
//     furnishedStatus: [],
//     postedBy: [],
//     availabilityStatus: [],
//     amenities: [],
//     reraApproved: [],
//     withPhotos: false,
//     withVideos: false,
//   });

//   const [budgetRange, setBudgetRange] = useState([100, 10000000]); // in Rupees (100 to 10 Cr)
//   const [sizeRange, setSizeRange] = useState([100, 10000]);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js";
//     script.async = true;
//     script.onload = () => {
//       window.AOS.init({
//         duration: 800,
//         offset: 100,
//         once: true,
//         easing: "ease-in-out-cubic",
//       });
//     };
//     document.body.appendChild(script);

//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.css";
//     document.head.appendChild(link);

//     // Fetch API Data
//     const fetchData = async () => {
//       try {
//         const response = await api.get("/properties/");
//         const ListingLandProperties = response.data.data.filter(
//           (item) => item.type === "land"
//         );
//         setProjects(ListingLandProperties);
//         setFilteredProjects(ListingLandProperties);

//         console.log("Lands===>", response.data);
//       } catch (error) {
//         console.error("Error fetching land projects:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();

//     return () => {
//       if (document.body.contains(script)) document.body.removeChild(script);
//       if (document.head.contains(link)) document.head.removeChild(link);
//     };
//   }, []);

//   // Filter applying effect
//   useEffect(() => {
//     // Function to check if project matches filters
//     const matchFilters = (project) => {
//       const price = project.property?.expectedPrice; // price in rupees
//       const size = project.property?.carpetArea?.value;

//       // Budget filter check
//       if (price < budgetRange[0] || price > budgetRange[1]) return false;

//       // Size filter check
//       if (size < sizeRange[0] || size > sizeRange[1]) return false;

//       // Availability Status filter
//       if (
//         selectedFilters.availabilityStatus.length > 0 &&
//         !selectedFilters.availabilityStatus.includes(project.listingType)
//       )
//         return false;

//       // Amenities filter
//       if (
//         selectedFilters.amenities.length > 0 &&
//         !selectedFilters.amenities.every((amenity) =>
//           project.property?.amenities?.includes(amenity)
//         )
//       )
//         return false;

//       // With photos filter
//       if (selectedFilters.withPhotos && !(project.images?.length > 0))
//         return false;

//       // With videos filter
//       if (selectedFilters.withVideos && !(project.videos?.length > 0))
//         return false;

//       return true;
//     };

//     const filtered = projects.filter(matchFilters);
//     setFilteredProjects(filtered);
//   }, [projects, selectedFilters, budgetRange, sizeRange]);

//   return (
//     <div className="w-full bg-gray-50 py-10">
//       <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-10">
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
//           <div className="col-span-1">
//             <LandFilter
//               selectedFilters={selectedFilters}
//               setSelectedFilters={setSelectedFilters}
//               budgetRange={budgetRange}
//               setBudgetRange={setBudgetRange}
//               sizeRange={sizeRange}
//               setSizeRange={setSizeRange}
//             />
//           </div>
//           <div className="col-span-1 lg:col-span-3 flex flex-col gap-6 md:gap-8">
//             <div>
//               <h2 className="text-lg sm:text-xl md:text-2xl font-medium mb-2 text-gray-900">
//                 Land Properties for Sale in Bhubaneswar
//               </h2>
//               <p className="text-sm md:text-md lg:text-lg font-normal text-gray-600">
//                 Explore approved land listings with detailed information and
//                 verified ownership.
//               </p>
//             </div>
//             {loading ? (
//               <p className="text-center text-gray-500">Loading properties...</p>
//             ) : filteredProjects.length > 0 ? (
//               <div className="flex flex-col gap-6">
//                 {filteredProjects.map((project, index) => (
//                   <LandProjectCard
//                     key={project._id}
//                     project={project}
//                     index={index}
//                   />
//                 ))}
//               </div>
//             ) : (
//               <p className="text-center text-gray-500">
//                 No land properties found.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ListingLandProperties;
